import classNames from 'classnames';
import ReloadIcon from '../../../assets/svg/reload.svg?react';
import FJUtil from '../../../util/FJUtil';
import { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import styles from './FJImage.module.less';
import FJResourceItemLoading from '../FJResourceItemLoading/FJResourceItemLoading';
import FJConstant from '../../../constants/FJConstant';

const FJImage = (props, ref) => {
    const {
        imgSrc,
        boxClassName,
        imgClassName,
        loadingClassName,
        isShowLoading = false,
        style,
        children,
        isLoading,
        onClick,
        loadCallback,
        onRefresh,
    } = props;
    const [stateImgUrl, setStateImgUrl] = useState(imgSrc);
    const [stateIsLoadError, setStateIsLoadError] = useState(false);
    const [stateIsLoading, setStateIsLoading] = useState(false);
    useImperativeHandle(ref, () => ({
        refresh: _refresh,
    }));
    useEffect(() => {
        if (imgSrc === stateImgUrl) return;
        setStateImgUrl(imgSrc);
        isShowLoading && setStateIsLoading(true);
        loadCallback && loadCallback(FJConstant.LOADING);
    }, [imgSrc]);
    const _refresh = e => {
        FJUtil.forbidEvent(e);
        setStateIsLoadError(false);
        setStateIsLoading(true);
        setStateImgUrl(FJUtil.getReloadNewUrl(imgSrc));
        loadCallback && loadCallback(FJConstant.LOADING);
        onRefresh && onRefresh();
    };
    const _sourceLoaded = () => {
        setStateIsLoadError(false);
        setStateIsLoading(false);
        loadCallback && loadCallback(FJConstant.SUCCESS);
    };
    const _sourceError = () => {
        setStateIsLoadError(true);
        setStateIsLoading(false);
        loadCallback && loadCallback(FJConstant.ERROR);
    };
    const _onClick = e => {
        if (stateIsLoading || isLoading) {
            return;
        }
        onClick && onClick(e);
    };

    return (
        <div className={classNames(boxClassName)} onClick={_onClick} style={style}>
            <img
                src={stateImgUrl}
                className={classNames(styles.img, imgClassName)}
                onLoad={_sourceLoaded}
                onError={_sourceError}
                style={{ opacity: stateIsLoadError || stateIsLoading ? 0 : 1 }}
                loading='lazy'
            />
            {stateIsLoadError && (
                <div className={styles.reload} onClick={_refresh}>
                    <ReloadIcon />
                </div>
            )}
            {children}
            {(stateIsLoading || isLoading) && <FJResourceItemLoading className={loadingClassName} />}
        </div>
    );
};
export default forwardRef(FJImage);
